<!-- <template>
  <div class="settings-layout">
    <div class="left">
      <slot name="left" />
    </div>
    <div class="right">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
export default { name: "SettingsLayout" };
</script>

<style scoped>
.settings-layout{
  display: grid;
  grid-template-columns: 1fr 380px; /* ajusta a tu screenshot */
  gap: 24px;
  align-items: start;
}
.right{
  border-radius: 12px;
}

/* Responsive: ocultar preview panel en dispositivos móviles y tablets pequeñas */
@media (max-width: 960px) {
  .settings-layout {
    grid-template-columns: 1fr;
  }

  .right {
    display: none;
  }
}
</style> -->
<template>
  <div class="settings-layout" :class="{ 'one-col': !hasRight }">
    <div class="left">
      <slot name="left" />
    </div>

    <div v-if="hasRight" class="right">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
export default {
  name: "SettingsLayout",
  computed: {
    hasRight() {
      // Si el slot right no trae nada, no reserves columna
      return !!(this.$slots.right && this.$slots.right.length);
    },
  },
};
</script>

<style scoped>
.settings-layout{
  display: grid;
  grid-template-columns: 1fr 380px;
  gap: 24px;
  align-items: start;
}

.settings-layout.one-col{
  grid-template-columns: 1fr; /* full width */
}

.right{
  border-radius: 12px;
}

@media (max-width: 960px) {
  .settings-layout {
    grid-template-columns: 1fr;
  }

  .right {
    display: none;
  }
}
.left {
  display: flex;
  flex-direction: column;
}
</style>
